import { UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import { ProductStatus } from "../../types/product";
import { selectCss } from "../reuseables/native.comp";

export default function ProductStatusEditor({ methods }: { methods: UseFormReturn<any, any> }) {
  const { t, msg } = useTranslation();
  const status = useWatch({ name: "status", control: methods.control });

  return (
    <div className="mb-6">
      <h2 className="font-bold">{t(msg.product.productStatus)}</h2>
      <select className={selectCss + getStatusColor(status)} {...methods.register("status")}>
        <option value="active">{t(msg.product.active)}</option>
        <option value="private">{t(msg.product.private)}</option>
        <option value="draft">{t(msg.product.draft)}</option>
      </select>
    </div>
  );
}

const getStatusColor = (status: ProductStatus) => {
  switch (status) {
    case "draft":
      return "text-her-blue ";
    case "active":
      return "text-green-600 ";
    case "private":
      return "text-red-600 ";
    default:
      break;
  }
};
